module.exports = __webpack_public_path__ + "img/packages/bot_row_laptop.703b97.png";